// extracted by mini-css-extract-plugin
export default {"imgContainer":"RoomImage_imgContainer__G-3Eh"};